import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL; // or process.env.REACT_APP_API_URL

/* ================= FETCH MENU ================= */
export const fetchAdminMenu = createAsyncThunk(
  "adminMenu/fetchAdminMenu",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(`${API_URL}/api/admin-menu`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return res.data.data ?? res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch admin menu"
      );
    }
  }
);

/* ================= ADD MENU ================= */
export const addAdminMenu = createAsyncThunk(
  "adminMenu/addAdminMenu",
  async (payload, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.post(
        `${API_URL}/api/admin-menu`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return res.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to add admin menu"
      );
    }
  }
);

const adminMenuSlice = createSlice({
  name: "adminMenu",
  initialState: {
    menu: [],
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetStatus: (state) => {
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      /* ================= FETCH ================= */
      .addCase(fetchAdminMenu.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdminMenu.fulfilled, (state, action) => {
        state.loading = false;
        state.menu = action.payload;
      })
      .addCase(fetchAdminMenu.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ================= ADD ================= */
      .addCase(addAdminMenu.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(addAdminMenu.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.menu.push(action.payload);
      })
      .addCase(addAdminMenu.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetStatus } = adminMenuSlice.actions;
export default adminMenuSlice.reducer;
